var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaloaltoprisma(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2578 18.9443L27.8335 15.4902L24.4092 18.9443L26.1065 20.6714L17.5308 29.3066L20.9551 32.7607L24.3794 29.3066L22.6821 27.5796L31.2578 18.9443ZM12.4092 24.1255L15.8335 27.5796L24.4092 18.9443L20.9849 15.4902L12.4092 24.1255ZM24.3794 29.2768L27.8037 32.7309L36.3794 24.0957L32.9849 20.6416L24.3794 29.2768Z",
    fill: "#FA582D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaloaltoprisma);
export default __webpack_public_path__ + "static/media/paloaltoprisma.0b30abad894ab3458558b95ee939e901.svg";
export { ForwardRef as ReactComponent };